// This plugin looks for promo codes in url query string and trys to apply them
export default function ({ route, store }) {
    if (route.query.promoCode)
        store
            .dispatch('checkout/addPromoCode', route.query.promoCode)
            .then((data) => {
                let message = 'Promo code successfully applied!'
                if (data.code === 'PROMO_CODE_NOT_APPLIED')
                    message =
                        'Promo code is now active, add the items to your cart for your discount.'

                store.dispatch('addGeneralSuccess', {
                    message,
                })
            })
            .catch((err) => {
                let message = 'Promo code not valid.'

                if (err.code === 'PROMO_CODE_EXISTS')
                    message = 'Promo code has already been applied.'
                else if (err.code === 'SIMILAR_PROMO_CODE_EXISTS')
                    message = 'Promo code cannot be applied.'

                store.dispatch('addGeneralError', {
                    message,
                })
            })
}
